export class HelmSetValue {
    Key!: string;
    Value!: string;
    constructor(key: string, value: string) {
        this.Key = key;
        this.Value = value;
    }
    public asString(newLine: string): string {
        return `--set ${this.Key.trim()}="${this.Value.trim()}" ${newLine}`;
    }
}
export class KubernetesAgentInstallationCommandBuilder {
    private readonly newLine: string;
    private readonly commandHeadTokens: string[];
    private readonly commandTailTokens: string[];
    private readonly commonHelmSetValues: HelmSetValue[] = [new HelmSetValue("agent.acceptEula", "Y")];
    private readonly releaseSpecificSetValues: HelmSetValue[] = [];
    constructor(version: string, namespace: string, releaseName: string, registryUrl: string, lineBreakCharacter: string) {
        this.newLine = `${lineBreakCharacter}\n`;
        this.commandHeadTokens = ["helm upgrade --install --atomic ", this.newLine, `--create-namespace --namespace ${namespace} `, this.newLine, `--version "${version}" `, this.newLine];
        this.commandTailTokens = [releaseName, " ", this.newLine, registryUrl];
    }
    public withCommonHelmSetValues(spaceName: string, serverUrl: string, serverCommsAddress: string, bearerToken: string): KubernetesAgentInstallationCommandBuilder {
        this.commonHelmSetValues.push(new HelmSetValue("agent.space", spaceName));
        this.commonHelmSetValues.push(new HelmSetValue("agent.serverUrl", serverUrl));
        this.commonHelmSetValues.push(new HelmSetValue("agent.serverCommsAddresses", `{${serverCommsAddress}}`));
        this.commonHelmSetValues.push(new HelmSetValue("agent.bearerToken", bearerToken));
        return this;
    }
    public withReleaseSpecificSetValues(setValues: HelmSetValue[]) {
        setValues
            .filter((kvp) => kvp.Key.trim() !== "" && kvp.Value.trim() !== "")
            .forEach((v) => {
            this.releaseSpecificSetValues.push(v);
        });
        return this;
    }
    public toCommandString(): string {
        const allTokens = this.commandHeadTokens
            .concat(this.commonHelmSetValues.map((kv) => kv.asString(this.newLine)))
            .concat(this.releaseSpecificSetValues.map((kv) => kv.asString(this.newLine)))
            .concat(this.commandTailTokens);
        return allTokens.join("").trim();
    }
}
